// File: store/myList.js
// Purpose: State store for the My List view. The actual data lives in
//          localStorage via services/watchlist.js; the view reads it directly.
export default {
  header: "My List",
  view: "MyList"
};
